import {
  productFamilyImageIdFormat,
  productIdFormat,
  productImageIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const ImageSchema_ = z.object({
  id: z.union([productFamilyImageIdFormat.schema, productImageIdFormat.schema]),
  url: z.string(),
  altText: z.string(),
  thumbhash: z.string().nullish(),
  position: z.number(),
  isDefault: z.boolean(),
});
export const ImageSchema: z.ZodType<ImageSchema> = ImageSchema_;
export interface ImageSchema extends z.infer<typeof ImageSchema_> {}

const ProductImagesSchema_ = z.object({
  productId: productIdFormat.schema,
  productTitle: z.string(),
  images: z.array(ImageSchema),
});
export const ProductImagesSchema: z.ZodType<ProductImagesSchema> =
  ProductImagesSchema_;
export interface ProductImagesSchema extends z.infer<
  typeof ProductImagesSchema_
> {}

const SelectedImageSchema_ = z.object({
  imageId: z.union([
    productFamilyImageIdFormat.schema,
    productImageIdFormat.schema,
  ]),
  source: createEnum(["product_family", "product"]),
  position: z.number(),
});
export const SelectedImageSchema: z.ZodType<SelectedImageSchema> =
  SelectedImageSchema_;
export interface SelectedImageSchema extends z.infer<
  typeof SelectedImageSchema_
> {}
